import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });

export const fetchSubscriptions = async (token) => {
  const response = await api.get('/subscriptions', {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const renewSubscription = async (subscriptionId, token) => {
  const response = await api.post(
    `/subscriptions/${subscriptionId}/renew`,
    {},
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};